import { dayjs } from './dayjs.utils';

// eslint-disable-next-line import/prefer-default-export
export const getDateString = (date: string) => dayjs(date).format('YYYY-MM-DD');
